import React from "react"
import AddMethodPaymentModal from "../../../../components/PaymentMethodTab/AddPaymentMethodModal"


const PaymentModal = ({ userId, userData, disabled, removeOld, isBillingAccount, setTriggerMethodAdded = null, acceptedPaymentMethods }) => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex justify-end w-full">
        <div>
          <AddMethodPaymentModal
            userId={userId}
            userData={userData}
            disabled={disabled}
            setTriggerMethodAdded={setTriggerMethodAdded}
            customButton={isBillingAccount ? 'Change Payment Method' : 'Payment Method'}
            customClasses={`${isBillingAccount ? 'w-[200px]' : 'w-[156px]'} h-[38px] bg-primary-main text-white font-bold cursor-pointer text-sm hover:bg-primary-main/90 rounded-lg text-center`}
            removeOld={removeOld}
            acceptedPaymentMethods={acceptedPaymentMethods}
          />
        </div>
      </div>

    </div>
  )
}


export default PaymentModal